




























































import { Vue, Component, Emit } from 'vue-property-decorator'
import ServerError from '@/utils/server_error'
import { MemberAPI } from '@/api/member'

@Component
export default class CompleteUserProfile extends Vue {
  rules: any = {}
  form = {
    nickname: '',
    avatar: null,
    country: undefined
  }
  validate = false
  loading = false

  created() {
    this.rules['nickname'] = [
      (v: any) => !!v || this.$t('RegistrationForm.UsernameIsRequired'),
      (v: any) =>
        (v && v.length >= 6) ||
        this.$t('RegistrationForm.UsernameMustHaveAtLeast6Characters')
    ]
    this.rules['country'] = [
      (v: any) => !!v || this.$t('RegistrationForm.CountryIsRequired')
    ]
  }

  async onSubmit() {
    this.loading = true

    try {
      await MemberAPI.editProfile({
        nickname: this.form.nickname,
        country: this.form.country
      })
      this.next()
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error('System error. Please try again later')
      }
      console.error(err)
    } finally {
      this.loading = false
    }
  }

  get countryList() {
    return [
      {
        text: this.$t('CompleteUserProfileDetails.HongKong'),
        value: 'HK'
      },
      {
        text: this.$t('CompleteUserProfileDetails.Taiwan'),
        value: 'TW'
      }
    ]
  }

  @Emit('next')
  next() {}

  reset() {
    this.form = {
      nickname: '',
      avatar: null,
      country: undefined
    }
  }
}
